import React, { useState, useEffect } from "react";
import { Box, Button, IconButton, Drawer, List, ListItem } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { Link, useLocation } from "react-router-dom";
import underline from "../../assets/underline.png";

const Topbar = ({ isAuthenticated }) => {
  const [scrolling, setScrolling] = useState(false);
  const [isAtTop, setIsAtTop] = useState(true);
  const [mobileOpen, setMobileOpen] = useState(false); // State for mobile menu
  const location = useLocation();

  const isLandingPage = location.pathname === "/";

  const handleScroll = () => {
    const firstSectionHeight = window.innerHeight;
    setScrolling(window.scrollY > 10);
    setIsAtTop(window.scrollY < firstSectionHeight - 100);
  };

  const scrollToFooter = () => {
    const footer = document.getElementById("footer");
    if (footer) {
      footer.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    if (isLandingPage) {
      window.addEventListener("scroll", handleScroll);
      handleScroll(); // Call immediately to check initial position
    } else {
      setIsAtTop(false);  // Ensure the topbar is always visible on other pages
      setScrolling(true);
    }
    return () => {
      if (isLandingPage) {
        window.removeEventListener("scroll", handleScroll);
      }
    };
  }, [isLandingPage]);

  // const menuItems = ["Gallery", "Design", "Shop", "About", "Contact"];
  // if (isAuthenticated) {
  //   menuItems.push("Admin");
  // }

  const menuItems = ["Gallery", "Shop", "Contact"];
  if (isAuthenticated) {
    menuItems.push("Admin");
  }

  return (
    <>
      {/* Desktop Navbar */}
      <Box
        position="fixed"
        top="20px"
        left="50%"
        transform="translateX(-50%)"
        sx={{
          display: { xs: "none", md: "flex" }, // Hidden on mobile, visible on desktop
          justifyContent: "center",
          alignItems: "center",
          background: isLandingPage
            ? isAtTop
              ? "1px solid transparent"
              : "1px solid rgba(0, 0, 0, 0.1)"
            : "1px solid rgba(0, 0, 0, 0.1)",
          borderRadius: "100px",
          border: isLandingPage
            ? isAtTop
              ? "1px solid transparent"
              : "1px solid rgba(0, 0, 0, 0.1)"
            : "1px solid rgba(0, 0, 0, 0.1)",
          boxShadow: isLandingPage
            ? isAtTop
              ? "0 0 20px 0 rgba(255, 255, 255, 0)"
              : "0 0 20px 0 rgba(0, 0, 0, 0.1)"
            : "0 0 20px 0 rgba(0, 0, 0, 0.1)",
          backdropFilter: "blur(20px)",
          WebkitBackdropFilter: "blur(20px)",
          width: "40vw",
          maxWidth: "900px",
          padding: "1px 10px",
          zIndex: 1000,
          opacity: scrolling ? 1 : 0,
          transition: "opacity 0.3s ease-in-out, border 0.3s ease-in-out",
          pointerEvents: scrolling ? "auto" : "none",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-evenly",
            alignItems: "center",
            width: "100%",
          }}
        >
          {menuItems.map((item) => {
            const itemPath = `/${item.toLowerCase()}`;
            const isActive = location.pathname === itemPath;

            return (
              <Button
                key={item}
                color="inherit"
                component={isActive ? "button" : Link}
                to={isActive ? undefined : itemPath}
                onClick={(e) => isActive && e.preventDefault()}
                sx={{
                  fontFamily: "'Poppins', sans-serif",
                  textTransform: "none",
                  fontSize: "14px",
                  color: isLandingPage
                    ? isAtTop ? "#fff" : "#000"
                    : " rgba(0, 0, 0)",
                  transition: "color 0.3s ease-in-out",
                  position: "relative",
                  "&:hover": {
                    color: isAtTop ? "rgba(0, 0, 0, 0.6)" : "rgba(0, 0, 0, 0.6)",
                    backgroundColor: "transparent",
                  },
                  "&::after": {
                    content: "''",
                    position: "absolute",
                    bottom: "-5px",
                    left: "95%",
                    transform: isActive ? "translateX(-50%) scale(1.5)" : "translateX(-50%) scale(1.5)", // Keep scale 1 for active
                    width: "100px",
                    height: "28px",
                    backgroundImage: `url(${underline})`,
                    backgroundSize: "contain",
                    backgroundRepeat: "no-repeat",
                    opacity: isActive ? 1 : 0, // Keep the underline visible if active
                    transition: "opacity 0.3s ease-in-out, transform 0.3s ease-in-out",
                  },
                  "&:hover::after": {
                    opacity: 1,
                    transform: "translateX(-50%) scale(1.5)",
                  },
                }}
              >
                {item}
              </Button>
            );
          })}
          {/* <Button
            color="inherit"
            onClick={scrollToFooter}
            sx={{
              fontFamily: "'Poppins', sans-serif",
              textTransform: "none",
              fontSize: "14px",
              color: isLandingPage
                ? isAtTop ? "#fff" : "#000"
                : " rgba(0, 0, 0)",
              transition: "color 0.3s ease-in-out",
              position: "relative",
              "&:hover": {
                color: isAtTop ? "rgba(0, 0, 0, 0.6)" : "rgba(0, 0, 0, 0.6)",
                backgroundColor: "transparent",
              },
              "&::after": {
                content: "''",
                position: "absolute",
                bottom: "-10px",
                left: "85%",
                transform: "translateX(-50%) scale(1)",
                width: "100px",
                height: "28px",
                backgroundImage: `url(${underline})`,
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
                opacity: 0,
                transition: "opacity 0.3s ease-in-out, transform 0.3s ease-in-out",
              },
              "&:hover::after": {
                opacity: 1,
                transform: "translateX(-50%) scale(2)",
              },
            }}
          >
            Contact
          </Button> */}
        </Box>
      </Box>

      {/* Mobile Navbar */}
      <Box
        sx={{
          display: { xs: "flex", md: "none" }, // Hidden on desktop, visible on mobile
          position: "fixed",
          top: "10px",
          left: "10px",
          zIndex: 1100,
        }}
      >
        <IconButton onClick={() => setMobileOpen(true)}>
          <MenuIcon
            sx={{
              fontSize: 32,
              color: isLandingPage ? (isAtTop ? "#fff" : "#000") : "#000", // White when at top of landing page, otherwise black
            }}
          />
        </IconButton>
      </Box>

      {/* Drawer for Mobile */}
      <Drawer
        anchor="left"
        open={mobileOpen}
        onClose={() => setMobileOpen(false)}
        PaperProps={{
          sx: {
            background: "rgba(255, 255, 255, 0.29)", // Set a slight transparent background
            backdropFilter: "blur(10px)", // Optional blur effect for better transparency
          },
        }}
      >
        {/* 1/3 width (view width) */}
        <List sx={{ width: "40vw", paddingTop: "15px" }}>
          {menuItems.map((item) => (
            <ListItem key={item} sx={{ position: "relative" }}>
              <Button
                color="inherit"
                component={Link}
                to={`/${item.toLowerCase()}`}
                onClick={() => setMobileOpen(false)}
                sx={{
                  width: "100%",
                  textAlign: "left",
                  fontSize: "14px",
                  textTransform: "none",
                  fontFamily: "'Poppins', sans-serif",
                  position: "relative",
                  color: "rgb(255, 255, 255)",
                  "&:hover": {
                    color: "rgb(0, 0, 0, 0.6)",
                    backgroundColor: "transparent",
                  },
                  "&::after": {
                    content: "''",
                    position: "absolute",
                    bottom: "-5px",
                    left: "60%",
                    transform: "translateX(-50%) scale(1)",
                    width: "80px",
                    height: "22px",
                    backgroundImage: `url(${underline})`,
                    backgroundSize: "contain",
                    backgroundRepeat: "no-repeat",
                    opacity: 0,
                    transition: "opacity 0.3s ease-in-out, transform 0.3s ease-in-out",
                  },
                  "&:hover::after": {
                    opacity: 1,
                    transform: "translateX(-50%) scale(1.5)",
                  },
                }}
              >
                {item}
              </Button>
            </ListItem>
          ))}
          {/* <ListItem sx={{ position: "relative" }}>
            <Button
              color="inherit"
              onClick={() => {
                scrollToFooter();
                setMobileOpen(false);
              }}
              sx={{
                width: "100%",
                textAlign: "left",
                fontSize: "14px",
                textTransform: "none",
                fontFamily: "'Poppins', sans-serif",
                position: "relative",
                color: "rgb(255, 255, 255)",
                "&:hover": {
                  color: "rgb(0, 0, 0, 0.6)",
                  backgroundColor: "transparent",
                },
                "&::after": {
                  content: "''",
                  position: "absolute",
                  bottom: "-5px",
                  left: "75%",
                  transform: "translateX(-50%) scale(1.5)",
                  width: "100px",
                  height: "22px",
                  backgroundImage: `url(${underline})`,
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat",
                  opacity: 0,
                  transition: "opacity 0.3s ease-in-out, transform 0.3s ease-in-out",
                },
                "&:hover::after": {
                  opacity: 1,
                  transform: "translateX(-50%) scale(1.5)",
                },
              }}
            >
              Contact
            </Button>
          </ListItem> */}
        </List>
      </Drawer>

    </>
  );
};

export default Topbar;
